import { useEffect, useState } from 'react';
import { css } from '@emotion/react';
import { authnClient, fetchSession } from '@frontend/auth';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { ContentLoader, Modal, PrimaryButton, TextLink, useModalControl } from '@frontend/design-system';
import { PasswordReset } from './password-reset';

export const OktaSignIn = () => {
  const { t } = useTranslation('SignIn');
  const { modalProps, triggerProps } = useModalControl();
  const [isChecking, setIsChecking] = useState(false);

  useEffect(() => {
    setIsChecking(true);
    fetchSession()
      .then((res) => {
        if (res) {
          authnClient.signIn();
        }
      })
      .finally(() => {
        setIsChecking(false);
      });
  }, []);

  return (
    <>
      <ContentLoader show={isChecking} message={t('Checking for existing session')} />
      <PrimaryButton
        disabled={isChecking}
        css={css`
          margin: ${theme.spacing(2, 0)};
          width: 100%;
        `}
        onClick={() => authnClient.signIn()}
      >
        {t('Sign In')}
      </PrimaryButton>
      <TextLink
        css={css`
          cursor: pointer;
          font-size: ${theme.fontSize(12)};
          margin-top: ${theme.spacing(2)};
          margin-bottom: ${theme.spacing(1)};
          text-align: center;
          width: 100%;
        `}
        onClick={triggerProps.onClick}
      >
        {t('Forgot your password?')}
      </TextLink>
      <Modal {...modalProps}>
        <PasswordReset modalProps={modalProps} />
      </Modal>
    </>
  );
};
